export const UI_LOCK = 'UI_LOCK';
export const API_ERROR = 'API_ERROR';
